import { Link, useAsyncValue, useLocation } from "react-router-dom";
import { useCart } from "../../../app/context/cart-context/cart-context";
import { useEffect, useState } from "react";
import { motion } from "framer-motion";

import { AddToCartBtn } from "../buttons/add-to-cart-btn/add-to-cart-btn";
import { QuantitySelector } from "../inputs/quantity-selector/quantity-selector";

import './product-card.css';

import food from "../../../assets/images/icons/food.svg";


export const ProductCard = ({children, props}) => {

    const animation = {
        hidden: { opacity: 0, y: -100 },
        show: {
          opacity: 1,
          y: 0,
          transition: {
            staggerChildren: 0.7,
            duration: 0.5,
            type: 'spring',
            damping: 10,
            stiffness: 100 
          }
        }
      };

    return (
        <motion.div
            variants={animation}
            initial="hidden"
            animate="show"
        >
                <Link to={`/product/${props.id}`} className={`product-card col-12 mb-1 py-2 border-bottom`}>
                    <div className="row">
                        <div className="col-8">
                            <div className="col-12 product-title"> <span>{props.name}</span></div>
                            <div className="col-12 product-description">Lorem ipsum dolor sit, amet consectetur adipisicing.</div>
                            {children ? 
                                children :
                            <div className="col-12 product-price"><span>{props.price} грн</span></div>}
                        </div>
                        <div className="col-4 d-flex justify-content-end">
                            { props.img ?
                                <img src={props.img} alt={props.name} /> :
                                <img src={food} alt="aboba" />
                            }
                        </div>
                    </div>
                </Link>
        </motion.div>
     )
    
}